import { useEffect } from 'react'

/**
 * Verhindert applikationsweit, dass fokussierte `input[type=number]`-Felder
 * ihren Wert beim Scrollen mit dem Mausrad ändern (Standard-Browserverhalten).
 *
 * Pattern: Capture-Listener auf `document` — trifft das Wheel-Event ein
 * fokussiertes Number-Input, wird es geblurrt. Das Blur passiert während der
 * Event-Dispatch-Phase, also bevor der Browser die Default-Action (Wert
 * inkrementieren/dekrementieren) ausführt. Die Seite scrollt normal weiter,
 * Pfeiltasten und Tippen bleiben unberührt.
 *
 * `passive: true` ist korrekt: wir rufen kein `preventDefault()` auf,
 * der Scroll selbst soll ja durchlaufen.
 *
 * Folge-Empfehlung (nicht Teil von STORY-917): längerfristig eine zentrale
 * NumberInput-Komponente in `src/components/ui/` etablieren statt 46 einzelner
 * `<input type="number">`, damit Formatierung/Validierung ebenfalls zentral sind.
 */
export function usePreventNumberInputWheel(): void {
  useEffect(() => {
    const handleWheel = (event: WheelEvent) => {
      const target = event.target
      if (
        target instanceof HTMLInputElement &&
        target.type === 'number' &&
        target === document.activeElement
      ) {
        target.blur()
      }
    }

    document.addEventListener('wheel', handleWheel, { passive: true, capture: true })
    return () => {
      document.removeEventListener('wheel', handleWheel, { capture: true })
    }
  }, [])
}
